import { Component, OnInit } from '@angular/core';
import { FaqCategory } from './models/faq-category.model';
import { FaqCollection } from './models/faq-collection.model';
import { FaqGroup } from './models/faq-group.model';
import { Question } from './models/question.model';
import { getFaqCategories, getFaqCategoriesFaqs, getHelpResourcesState, HelpResourcesState } from '@emi/shared/state/help-resources';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Faq } from '@emi/shared/models';

@Component({
    selector: 'via-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
    public faqCollection: FaqCollection = {
        faqGroups: [],
        popularFaqs: [],
    };

    public selectedFaqId: number | null = null;

    private preventScroll: boolean = true;

    private helpResourcesStateSubscription: Subscription;

    constructor(private readonly helpResourcesStore: Store<HelpResourcesState>) {}

    public ngOnInit(): void {
        this.helpResourcesStateSubscription = this.helpResourcesStore.pipe(select(getHelpResourcesState)).subscribe((state) => {
            this.faqCollection = this.buildFaqCollection(
                state.faqCategories.map((x) => new FaqCategory(x.id, x.name, x.displayOrder)),
                state.faqs.map((x) => new Faq(x.id, x.title, x.description, x.faqCategoryId, x.displayOrder, x.rank))
            );
        });

        this.helpResourcesStore.dispatch(getFaqCategories());

        this.helpResourcesStore.dispatch(getFaqCategoriesFaqs());
    }

    public ngOnDestroy(): void {
        this.helpResourcesStateSubscription.unsubscribe();
    }

    private buildFaqCollection(faqCategories: FaqCategory[], questions: Question[]): FaqCollection {
        const faqCollection = new FaqCollection();

        for (let category of faqCategories) {
            faqCollection.faqGroups.push(new FaqGroup(category.id, category.name, category.displayOrder));
        }

        faqCollection.faqGroups.sort((x, y) => x.displayOrder - y.displayOrder);

        for (let faqGroup of faqCollection.faqGroups) {
            faqGroup.questions = questions.filter((q) => q.faqCategoryId === faqGroup.categoryId);
            faqGroup.questions.sort((x, y) => x.displayOrder - y.displayOrder);
        }

        faqCollection.popularFaqs = questions.filter((q) => q.rank !== 0).sort((x, y) => x.rank - y.rank);

        return faqCollection;
    }

    public expandPopularFaq(id: number): void {
        this.preventScroll = false;
        this.selectedFaqId = id;
    }

    public scrollToFaq(question: Question): void {
        this.selectedFaqId = question.id;

        if (!this.preventScroll) {
            const element = document.getElementById(`id${question.id}`) as HTMLElement;
            element.scrollIntoView({
                behavior: 'smooth',
            });
        }

        this.preventScroll = true;
    }

    public resetSelectedFaq(question: Question): void {
        if (this.selectedFaqId === question.id) {
            this.selectedFaqId = 0;
        }
    }
}
